import { useState, useCallback } from 'react';

interface ShareButtonProps {
  shareLink: string | null;
  onShare: () => Promise<string | null>;
}

export function ShareButton({ shareLink, onShare }: ShareButtonProps) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const handleShare = useCallback(async () => {
    const link = await onShare();
    if (!link) return;

    if (navigator.share) {
      try {
        await navigator.share({ title: 'AbastoVirtual - Carrito', url: link });
        return;
      } catch (err) {
        if ((err as Error).name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(link);
      setToastMessage('Link copiado al portapapeles');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error('Failed to copy:', err);
      setToastMessage('Error al copiar el link');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  }, [onShare]);

  return (
    <>
      <button
        type="button"
        className="flex items-center justify-center w-10 h-10 border-none bg-green-600 text-white rounded-lg cursor-pointer transition-colors duration-150 hover:enabled:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleShare}
        title="Compartir carrito"
        disabled={!shareLink}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      </button>

      {showToast && (
        <div className="fixed top-5 right-5 flex items-center gap-2 bg-gray-800 text-white py-3 px-5 rounded-lg text-sm shadow-lg z-[1000] animate-slide-in">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          {toastMessage}
        </div>
      )}
    </>
  );
}
